import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';
import { isNotificationForCurrentProject } from '@/common/utils/notifications/isNotificationForCurrentProject';

type MassAddMigrationsPayload = {
  project_id?: string;
  target_project?: { id?: string };
};

type MassAddMigrationsSuccessPayload = MassAddMigrationsPayload & {
  instances?: unknown[];
};

const taskMap: TaskMap = {
  [TaskName.MAAS_ADD_MIGRATIONS_PROCESS]: {
    [TaskState.RUNNING]: ({ payload }: { payload: MassAddMigrationsPayload }) => {
      if (!isNotificationForCurrentProject(payload.project_id ?? payload.target_project?.id)) return false;
      return {
        message: i18n.t('Creating migration...')
      };
    },
    [TaskState.SUCCESS]: ({ payload }: { payload: MassAddMigrationsSuccessPayload }) => {
      if (!isNotificationForCurrentProject(payload.project_id ?? payload.target_project?.id)) return false;
      const instancesCount = Array.isArray(payload.instances) ? payload.instances.length : 0;
      const count = instancesCount || 1;
      return {
        title: i18n.t('Migration created'),
        message: i18n.tc('Migration successfully created|{num} migrations successfully created', count, { num: count })
      };
    },
    [TaskState.FAILED]: ({ error, payload }: { error?: string; payload: MassAddMigrationsPayload }) => {
      if (!isNotificationForCurrentProject(payload.project_id ?? payload.target_project?.id)) return false;
      return {
        title: i18n.t('Operation failed'),
        message: error || i18n.t('Operation failed')
      };
    }
  }
};

export default taskMap;
